import { createFileRoute } from '@tanstack/react-router'
import { FreeSWITCHTrunksPage } from '@/features/freeswitch'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/freeswitch/trunks/')({
  component: FreeSWITCHTrunksPage,
  beforeLoad: requireRole(['admin']),
})
